




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Site } from '@/store/modules/projects/types/projects.types';
import { cloneDeep as _cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
  },
})
export default class SiteModal extends Vue {
  @Prop()
  public modalTitle!: string;

  @Prop()
  public siteDetail!: Site;

  // @ts-ignore
  public dirtySite: Site = {
    id: 0,
    name: '',
    address: '',
    description: '',
    isIdentifierRequired: false,
  };

  public addSite() {
    this.$emit('addNewSite', this.dirtySite);
    this.$emit('close');
  }

  public closeModal() {
    this.$emit('close');
  }

  public mounted() {
    this.dirtySite = _cloneDeep(this.siteDetail);
  }
}
